export const CustomFormMessage = ({ children }: { children: React.ReactNode }) => (
  <p className="text-14 font-[400] text-[#EA5455]">{children}</p>
);
